import React from "react";
import wordmark from "../assets/images/wordmark.png";

/**
 * HeyPop brand wordmark — the official "heyPOP ✨" sparkle wordmark image.
 * `size` is the nominal letter height in px; the image scales to it.
 */
export default function HeyPopWordmark({ size = 28, className = "" }) {
  return (
    <img
      src={wordmark}
      alt="heyPOP"
      className={className}
      style={{ height: `${Math.round(size * 1.5)}px`, width: "auto", display: "block" }}
    />
  );
}
